/* eslint-disable no-console */
import { BrowserAgent } from "@newrelic/browser-agent";
import { getNewRelic } from "../../bootstrap/new-relic";

const newRelicInstance: BrowserAgent | null = getNewRelic();

export class Logger {
  static env = process.env.REACT_APP_ENV;

  static log(context: string, ...args: unknown[]) {
    console.log(`[${this.env} ${context} Logger]: `, ...args);
  }

  static info = (context: string, ...args: unknown[]) => {
    console.info(`[${this.env} ${context} Logger]: `, ...args);
  };

  static warn(context: string, ...args: unknown[]) {
    console.warn(`[${this.env} ${context} Logger]: `, ...args);
  }

  static error(context: string, ...args: Error[]) {
    console.error(`[${this.env} ${context} Logger]: `, ...args);
    if (newRelicInstance) {
      args.map((error) => newRelicInstance.noticeError(error, { context }));
    }
  }
}
